import queryString from 'query-string'

const state = {
    loaderData: true
}

const mutations = {
    setLoader: (states, payload) => {
        states.loaderData = payload;
    }
}

const getters = {
    loadingPageData: (states) => states.loaderData
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
};